export enum TargetAudience {
  All = 0,
  VetsOnly = 1
}

export interface ImportantAlert {
  id: number;
  title: string;
  message: string;
  targetAudience: TargetAudience;
  isActive: boolean;
  createdAt: string;
  createdByUserId: number;
}
